module.exports = __webpack_public_path__ + "static/walls--green@3x.53a4c5a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/walls--green@3x.png
// module id = 709
// module chunks = 126511778744290